export default __webpack_public_path__ + "static/media/emptyFilterResult.5faaea5c.svg";